(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  document.documentElement.classList.add('js');
  const intro = document.querySelector('.intro');
  intro?.addEventListener('animationend', e => { if (e.target === intro) intro.remove(); });
  setTimeout(() => intro?.remove(), 1900);
  const menu = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.navigation');
  const closeMenu = () => { nav.hidden = true; menu.setAttribute('aria-expanded', 'false'); };
  menu.addEventListener('click', () => { nav.hidden = !nav.hidden; menu.setAttribute('aria-expanded', String(!nav.hidden)); });
  nav.addEventListener('click', e => { if (e.target.closest('a')) closeMenu(); });
  document.addEventListener('click', e => { if (!e.target.closest('.header')) closeMenu(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !reduced.matches) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.remove('waiting'); entry.target.classList.add('visible'); observer.unobserve(entry.target); }
    }), { threshold: 0.08 });
    reveals.forEach(el => { el.classList.add('waiting'); observer.observe(el); });
  } else reveals.forEach(el => el.classList.add('visible'));
  const mobileSections = matchMedia('(max-width: 760px)');
  [['#materiel', '#equipment-toggle', 'Voir le matériel et le retour image', 'Masquer le matériel et le retour image'], ['#questions', '#faq-toggle', 'Voir les questions fréquentes', 'Masquer les questions']].forEach(([sectionSelector, toggleSelector, closedLabel, openLabel]) => {
    const section = document.querySelector(sectionSelector);
    const toggle = document.querySelector(toggleSelector);
    let mobileOpen = false;
    const updateDisclosure = () => {
      const expanded = !mobileSections.matches || mobileOpen;
      section.classList.toggle('is-collapsed', !expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.querySelector('span').textContent = expanded ? openLabel : closedLabel;
    };
    toggle.addEventListener('click', () => { mobileOpen = !mobileOpen; updateDisclosure(); });
    mobileSections.addEventListener('change', updateDisclosure);
    updateDisclosure();
  });
  const equipmentDialog = document.querySelector('#equipment-dialog');
  document.querySelectorAll('[data-equipment]').forEach(button => button.addEventListener('click', () => {
    equipmentDialog.classList.toggle('color-backdrops-preview', button.classList.contains('color-backdrops-item'));
    equipmentDialog.querySelector('img').src = button.dataset.equipment;
    equipmentDialog.querySelector('img').alt = button.dataset.name;
    equipmentDialog.querySelector('h2').textContent = button.dataset.name;
    equipmentDialog.querySelector('p').textContent = button.dataset.description;
    equipmentDialog.querySelector('.equipment-kind').textContent = button.dataset.kind;
    const source = equipmentDialog.querySelector('a');
    source.hidden = !button.dataset.source;
    if (button.dataset.source) source.href = button.dataset.source;
    else source.removeAttribute('href');
    equipmentDialog.showModal();
  }));
  const photoDialog = document.querySelector('#photo-dialog');
  const openPhoto = button => {
    photoDialog.querySelector('img').src = button.dataset.photo;
    photoDialog.querySelector('img').alt = button.dataset.caption;
    photoDialog.querySelector('p').textContent = button.dataset.caption;
    photoDialog.showModal();
  };
  document.querySelectorAll('[data-photo]:not(.showcase-card)').forEach(button => button.addEventListener('click', () => openPhoto(button)));
  document.querySelector('#credits-button').addEventListener('click', () => document.querySelector('#credits-dialog').showModal());
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.querySelector('.dialog-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => {
      const r = dialog.getBoundingClientRect();
      if (e.target === dialog && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) dialog.close();
    });
  });
  const tour = document.querySelector('.tour');
  const tourCards = [...document.querySelectorAll('[data-tour-index]')];
  const tourTabs = [...document.querySelectorAll('[data-tour-tab]')];
  const descriptions = [...document.querySelectorAll('.tour-description[data-description]')];
  let currentTour = 0, manualY = null;
  descriptions.forEach((el, i) => { el.querySelector('span').textContent = `0${i + 1} / 04`; });
  function setTour(index) {
    currentTour = index;
    tourCards.forEach((el, i) => { el.classList.toggle('is-active', i === index); el.setAttribute('aria-hidden', String(i !== index)); el.tabIndex = i === index ? 0 : -1; });
    descriptions.forEach((el, i) => el.classList.toggle('is-active', i === index));
    tourTabs.forEach((el, i) => { el.setAttribute('aria-selected', String(i === index)); el.tabIndex = i === index ? 0 : -1; });
  }
  tourTabs.forEach((button, i) => {
    button.addEventListener('click', () => { manualY = scrollY; setTour(i); });
    button.addEventListener('keydown', e => {
      let next;
      if (e.key === 'ArrowRight') next = (i + 1) % 4;
      if (e.key === 'ArrowLeft') next = (i + 3) % 4;
      if (e.key === 'Home') next = 0;
      if (e.key === 'End') next = 3;
      if (next !== undefined) { e.preventDefault(); manualY = scrollY; setTour(next); tourTabs[next].focus(); }
    });
  });
  const deck = document.querySelector('.showcase-deck');
  const cards = [...document.querySelectorAll('[data-showcase]')];
  const previous = document.querySelector('.showcase-prev');
  const next = document.querySelector('.showcase-next');
  let selected = 2;
  function arrangeGallery(index = selected) {
    selected = Math.max(0, Math.min(cards.length - 1, index));
    const step = innerWidth < 760 ? 100 : 195;
    cards.forEach((card, i) => {
      const delta = i - selected, distance = Math.abs(delta);
      card.style.transform = `translateX(calc(-50% + ${delta * step}px)) translateY(${distance * 20}px) rotate(${delta * 8}deg) rotateY(${-delta * 6}deg) scale(${1 - distance * .1})`;
      card.style.zIndex = String(10 - distance);
      card.style.opacity = distance > 2 ? '0' : String(distance ? .88 : 1);
      card.style.visibility = distance > 2 ? 'hidden' : 'visible';
      card.tabIndex = delta === 0 ? 0 : -1;
      card.setAttribute('aria-label', delta === 0 ? `Agrandir : ${card.dataset.caption}` : `Sélectionner : ${card.dataset.caption}`);
      card.classList.toggle('is-active', delta === 0);
    });
    document.querySelector('.showcase-count').textContent = `0${selected + 1} / 0${cards.length}`;
    previous.disabled = selected === 0; next.disabled = selected === cards.length - 1;
  }
  cards.forEach((card, i) => card.addEventListener('click', () => { if (i === selected) openPhoto(card); else arrangeGallery(i); }));
  previous.addEventListener('click', () => arrangeGallery(selected - 1));
  next.addEventListener('click', () => arrangeGallery(selected + 1));
  deck.addEventListener('keydown', e => { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); arrangeGallery(selected + (e.key === 'ArrowLeft' ? -1 : 1)); } });
  arrangeGallery(); setTour(0);
  const stage = document.querySelector('.hero-stage');
  let ticking = false;
  function updateScroll() {
    ticking = false;
    if (!reduced.matches) stage.style.setProperty('--depth', String(Math.min(1, Math.max(0, scrollY / 650))));
    if (manualY !== null && Math.abs(scrollY - manualY) > 35) manualY = null;
    const r = tour.getBoundingClientRect();
    if (manualY === null && r.top < 140 && r.bottom > innerHeight * .45) {
      const progress = Math.max(0, Math.min(.999, (110 - r.top) / Math.max(1, tour.offsetHeight - innerHeight * .85)));
      const index = Math.min(3, Math.floor(progress * 4));
      if (index !== currentTour) setTour(index);
    }
  }
  window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(updateScroll); ticking = true; } }, { passive: true });
  window.addEventListener('resize', () => { arrangeGallery(); updateScroll(); });
  stage.addEventListener('pointermove', e => {
    if (reduced.matches || e.pointerType !== 'mouse') return;
    const r = stage.getBoundingClientRect();
    stage.style.setProperty('--mouse-x', String((e.clientX - r.left) / r.width - .5));
    stage.style.setProperty('--mouse-y', String((e.clientY - r.top) / r.height - .5));
  });
  stage.addEventListener('pointerleave', () => { stage.style.setProperty('--mouse-x', '0'); stage.style.setProperty('--mouse-y', '0'); });
  reduced.addEventListener('change', () => { reveals.forEach(el => { el.classList.remove('waiting'); el.classList.add('visible'); }); updateScroll(); });
  updateScroll();
  const mapElement = document.querySelector('#studio-map');
  if (window.L && mapElement) {
    mapElement.querySelector('.map-fallback')?.remove();
    const map = L.map(mapElement, {scrollWheelZoom:false, zoomControl:false, dragging:!matchMedia('(pointer:coarse)').matches, tap:false});
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom:19, attribution:'&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>'
    }).addTo(map);
    L.control.zoom({zoomInTitle:'Zoomer',zoomOutTitle:'Dézoomer'}).addTo(map);
    const places = [
      {coords:[48.8186,2.378035],badge:'T7',name:'Studio T7',detail:'51 rue Mirabeau, Ivry-sur-Seine',studio:true},
      {coords:[48.815833,2.3775],badge:'M7',name:'Pierre et Marie Curie',detail:'Métro 7',studio:false},
      {coords:[48.824167,2.376944],badge:'T3a',name:'Maryse Bastié',detail:'Tram T3a',studio:false}
    ];
    places.forEach(place => {
      const icon = L.divIcon({className:`map-icon ${place.studio?'studio-pin':''}`,html:`<span>${place.badge}</span>`,iconSize:[44,44],iconAnchor:[22,22]});
      const marker = L.marker(place.coords,{icon,title:place.name,alt:place.name}).addTo(map);
      marker.bindTooltip(place.name,{permanent:true,direction:place.badge==='M7'?'bottom':'top',offset:place.badge==='M7'?[0,24]:[0,-24],className:'map-label'});
      marker.bindPopup(`<b>${place.name}</b><br>${place.detail}`);
    });
    const bounds = L.latLngBounds(places.map(place=>place.coords));
    const frameMap = () => {map.invalidateSize();map.fitBounds(bounds,{padding:[65,60],maxZoom:16});};
    frameMap();
    window.addEventListener('resize',frameMap);
  }
})();
